<template>
    <div class="signed-in-info-container">
        <div class="indicator indicator--trigger--click">
            <router-link  v-if="!userIsAuthenticated" to="/login" class="indicator__button">
                <span class="indicator__icon">
                    <svg width="32" height="32">
                    <path
                        d="M16,18C9.4,18,4,23.4,4,30H2c0-6.2,4-11.5,9.6-13.3C9.4,15.3,8,12.8,8,10c0-4.4,3.6-8,8-8s8,3.6,8,8c0,2.8-1.5,5.3-3.6,6.7 	C26,18.5,30,23.8,30,30h-2C28,23.4,22.6,18,16,18z M22,10c0-3.3-2.7-6-6-6s-6,2.7-6,6s2.7,6,6,6S22,13.3,22,10z"
                    />
                    </svg>
                </span>
                <span class="indicator__title">My Account </span>
                <span class="indicator__value">Log In </span>
            </router-link>

            <!-- <a v-else href="#" class="indicator__button">
                <span class="indicator__title-signed-in">Welcome,</span>
                <span class="indicator__value-signed-in">{{ billingdetails.billingname }}</span>
                <a href="javascript:void" class="log-out-header" @click.prevent="logout">Log Out</a>
            </a> -->

            <a v-else href="#" class="indicator__button">
                <span class="indicator__title-signed-in" style="font-size:12px;font-weight:400;">Welcome,</span><span class="indicator__value-signed-in" style="font-size:16px;font-weight:600;margin-top:-3px;">{{ billingdetails.billingname }}</span>
                <a href="javascript:void" class="log-out-header" @click.prevent="logout">Log Out</a>
            </a>
            

            <div class="indicator__content" v-if="!userIsAuthenticated">
                <div class="account-menu">
                    <form class="account-menu__form">
                    <div class="account-menu__form-title">
                        Log In to Your Account
                    </div>
                    <div class="form-group">
                        <label for="header-signin-email" class="sr-only"
                        >Email address
                        </label>
                        <input
                            id="header-signin-email"
                            type="text"
                            class="form-control form-control-sm"
                            placeholder="User ID"
                        />
                    </div>
                    <div class="form-group">
                        <label for="header-signin-password" class="sr-only"
                        >Password
                        </label>
                        <div class="account-menu__form-forgot">
                        <input
                            id="header-signin-password"
                            type="password"
                            class="form-control form-control-sm"
                            placeholder="Password"
                        />
                        <a href="" class="account-menu__form-forgot-link"
                            >Forgot?</a
                        >
                        </div>
                    </div>
                    <div class="form-group account-menu__form-button">
                        <button type="submit" class="btn btn-primary btn-sm" @click="login">
                            Login
                        </button>
                    </div>
                    <div class="account-menu__form-link">
                        <router-link to="/login">Create An Account</router-link>
                    </div>
                    </form>
                    <div class="account-menu__divider"></div>

                    <router-link class="account-menu__user" to="/account-addresses"  v-if="userIsAuthenticated">
                        <div class="account-menu__user-info">
                            <div class="account-menu__user-name">Ryan Ford</div>
                            <div class="account-menu__user-email">ryan@example.com</div>
                        </div>
                    </router-link>
                    <div class="account-menu__divider" v-if="userIsAuthenticated"></div>
                    <ul class="account-menu__links" v-if="userIsAuthenticated">
                        <li>
                            <router-link to="/account-orders">Order History</router-link>
                        </li>
                        <li>
                            <router-link to="/account-saved-qwik-orders">Your Saved Orders</router-link>
                        </li>
                        <li>
                            <router-link to="/account-garage">Your Saved Vehicles</router-link>
                        </li>
                        <li>
                            <router-link to="/account-addresses">Edit Profile and Addresses</router-link>
                        </li>
                    </ul>
                    <div class="account-menu__divider" v-if="userIsAuthenticated"></div>
                    <ul class="account-menu__links" v-if="userIsAuthenticated">
                        <li>
                            <router-link to="/login">Logout</router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    
    <!-- <div v-else class="signed-in-info-container">
        <span class="h6">Welcome </span>
        <span class="h6"></span>
        <a href="javascript:void" @click.prevent="logout">Logout</a>
    </div> -->
    
</template>

<script>
import MixinCustomer from '../../../mixins/customer.js';
import axiosvl from "../../../axios/axios-vl.js";
import { mapGetters } from 'vuex';

export default {
    mixins: [
        MixinCustomer
    ],
    methods: {
        logout() {

            this.$store.dispatch("cart/emptyCart");
            this.$store.dispatch("cart/emptyKits");
            this.$store.dispatch("vehicle/clearSelectedVehicle");
            this.$store.dispatch("setUserAttributes", []);
            this.$store.dispatch("resetCustomerDetails");
            this.$store.dispatch('setSolr_faceted_filter', {});
            this.$store.dispatch('logout');

            this.mx_getCustomerInformation();

            this.totals[0].shippingtotal = 0;
            this.totals[0].ordertotal = 0;
			this.$store.dispatch("cart/totals", this.totals[0]);

            this.$router.push('/home');
        },

        login() {
            this.isloading = true;
            this.servermessages, this.serverstatus, (this.servermessages = []);
            const login_uri = this.$store.getters['api/login_uri'];

            axiosvl.post(login_uri,
            {
                webroutine: {
                context: {
                    "session-key-method": "hidden",
                },
                fields: {
                    ecCust: {
                    value: this.user,
                    },
                    Pswd: {
                    value: this.password,
                    },
                },
                },
            })
            .then((response) => {
                this.password = "";
                const fields = response.data.webroutine.fields;

                this.serverstatus = fields.RESULTCOD.value;

                if (this.serverstatus === "OK") {
                    this.userValid, (this.passValid = "pending");
                    this.$store.dispatch("login", {
                        isAuth: true,
                        userid: this.user,
                        customer: fields.EHCUST.value,
                    });

                    

                    this.isloading = false;

                    // this.$router.push("/home");
                } else {
                    const messages = [];
                    const wrmessages = response.data.webroutine.messages;

                    for (var i = 0; i < wrmessages.length; i++) {
                    messages.push(wrmessages[i]);
                    }

                    // Return code is not "OK" but no messages appear, add a custom error message
                    if (messages.length === 0) {
                    messages.push("Something went wrong. Please try again later.");
                    }

                    this.servermessages = messages;
                }
            })
            .catch((error) => {
                this.servermessages.push(
                    "Something went wrong. Please try again later."
                );
                this.isloading = false;
                console.error("error - " + error);
            });

            // for testing
            // for auto login
            this.$store.dispatch("login", {
                isAuth: true,
                userid: this.user,
                customer: 'DMS',
            });
        },
    },
    computed: {
        ...mapGetters(['userIsAuthenticated', 'customer']),
        ...mapGetters('cart', ['billingdetails', 'totals'])
    },

    updated() {
        // console.log(this.billingdetails);
    }
}

</script>

<style scoped>
/* .signed-in-info-container {
   margin-right: 10px; 
}

.signed-in-info-container span.h6 {
    display: block;
} */
</style>